package net.frozenbit.games.soundgame.utils

import io.ktor.client.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.websocket.*
import io.ktor.client.request.url
import io.ktor.http.URLProtocol
import io.ktor.http.appendPathSegments
import io.ktor.http.takeFrom
import io.ktor.serialization.kotlinx.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.browser.window
import kotlinx.coroutines.currentCoroutineContext
import kotlinx.coroutines.delay
import kotlinx.coroutines.ensureActive
import kotlinx.coroutines.isActive
import kotlinx.serialization.json.Json
import kotlin.time.Duration.Companion.milliseconds
import kotlin.time.Duration.Companion.seconds

fun createClient(): HttpClient {
    val json = Json {
        prettyPrint = false
        isLenient = true
        ignoreUnknownKeys = true
    }
    val client = HttpClient {
        install(ContentNegotiation) {
            json(json)
        }
        install(WebSockets) {
            contentConverter = KotlinxWebsocketSerializationConverter(json)
        }
    }
    return client
}

suspend fun HttpClient.permanentSocketSession(
    url: String,
    onReconnected: suspend DefaultClientWebSocketSession.() -> Unit = {},
    block: suspend DefaultClientWebSocketSession.() -> Unit,
) {
    var sessionCounter = 0
    var attempts = 0
    while (currentCoroutineContext().isActive) {
        sessionCounter++
        println("Connection $sessionCounter")
        try {
            webSocket(
                request = {
                    url {
                        takeFrom(urlString = window.location.href)
                        appendPathSegments(url)
                        if (sessionCounter > 1) {
                            parameters.append("reconnect", "true")
                        }
                        protocol = when (window.location.protocol) {
                            "https:" -> URLProtocol.WSS
                            else -> URLProtocol.WS
                        }
                    }
                }
            ) {
                if (sessionCounter > 1) {
                    onReconnected()
                }
                attempts = 0
                block()
            }
        } catch (e: Exception) {
            ensureActive() // rethrow cancellation exceptions
            println("Connection $sessionCounter failed: $e")
        }
        println("Connection $sessionCounter closed")
        attempts++
        delay(
            minOf(
                100.milliseconds * attempts,
                1.seconds,
            )
        )
    }
}